import { Button, Modal, ModalHeader, ModalContent, Dropdown, Input } from "semantic-ui-react"
import { useEffect, useState } from 'react'
import { ActionButton } from "../common"
import { getCSRFToken, fetchWithAuth } from "../auth"

export const AddDeviceSubTypesModal = props => {
    const [open, setOpen] = useState(false)
    const [deviceTypeOptions, setDeviceTypeOptions] = useState([])
    const [modalContent, setModalContent] = useState(<></>)
    const [deviceType, setDeviceType] = useState('')
    const [name, setName] = useState('')

    function closeModal() {
        setOpen(false)
        setDeviceType('')
        setName('')
        resetModal()
    }
    async function handleResp(resp) {
        if (resp.status >= 400) {
            const respText = await resp.text()
            setModalContent((
                <div style={{ margin: "1rem", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <div>
                        There was an error: {respText}
                    </div>
                    <Button onClick={closeModal}>Close</Button>
                </div>
            ))
            return true
        } else {
            setModalContent((
                <div style={{ margin: "2rem", display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <div>
                        Success!
                    </div>
                    <Button style={{ margin: "1rem" }} onClick={closeModal}>Close</Button>
                </div>
            ))
            return false
        }
    }

    function addDeviceSubType() {

        async function postAddDeviceSubType() {
            const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'devicesubtypes/', {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    'X-CSRFToken': getCSRFToken()
                },
                credentials: 'include',
                body: JSON.stringify({
                    name: name,
                    deviceType: deviceType
                })
            })
            await handleResp(resp)

            props.refresh()


        }
        setModalContent(<div>Loading...</div>)
        postAddDeviceSubType()
    }

    async function getDeviceTypeOptions() {
        const resp = await fetchWithAuth(process.env.REACT_APP_ICC_TOOL_API_HOST + 'devicetypes/', {
            headers: {
                'X-CSRFToken': getCSRFToken()
            },
            credentials: 'include'
        })
        const respJson = await resp.json()
        let deviceTypeOptions = []
        deviceTypeOptions = respJson.map(devType => {
            return {
                key: devType.id,
                value: devType.id,
                text: devType.name
            }
        });
        setDeviceTypeOptions(deviceTypeOptions)
    }

    useEffect(() => {
        resetModal()
    }, [name, deviceType])

    function resetModal() {
        const content = (
            <>
                <ModalHeader>Add an asset subtype</ModalHeader>
                <ModalContent>
                    <div className="add-member-wrapper">
                        <div className="add-member">
                            <Input required={true} name="name" value={name} onChange={(e, data) => { setName(data.value) }} className="field-input spaced" placeholder="Name"></Input>

                            <Dropdown className="spaced" placeholder="Device Type" onChange={(e, data) => { setDeviceType(data.value); }} fluid search selection options={
                                deviceTypeOptions
                            } />

                            <div style={{ paddingTop: "1rem" }}>
                                <ActionButton submitAction={addDeviceSubType}
                                    resetHide={false}
                                    resetText={'Cancel'}
                                    showConfirmation={false}
                                    resetAction={closeModal} />
                            </div>
                        </div>
                    </div>
                </ModalContent>
            </>)
        setModalContent(content)
    }

    useEffect(() => {
        resetModal()
    }, [deviceTypeOptions])

    useEffect(() => {
        getDeviceTypeOptions()

    }, [])
    return (<Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        size={'mini'}
        trigger={<Button style={{backgroundColor: "var(--add)", color: "white"}}>Add an asset subtype</Button>}
    >{modalContent}</Modal>)
}
